<!--
 * @Description: 项目人员结算管理
 * @Date: 2024-08-17 16:38:28
-->
<template>
  <table-render
    style="padding: 0;"
    ref="tableRender"
    :config="config"
    rowKey="id"
  ></table-render>
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';

export default {
  name: 'projectPersonSettlement',
  data() {
    return {
      config: null
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {
    this.config = config;
  }
};
</script>

<style scoped lang="scss"></style>
